<ul class="nav">
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
    <span>{{tab.title}}</span>
  </li>
</ul>
<ng-content></ng-content>